<template>
  <section
    id="page-settings"
    class="page"
  >
    <b-overlay
      :show="loading"
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>
      <b-row style="position: relative">
        <b-col
          class="left-menu"
          lg="3"
          md="4"
          sm="12"
        >
          <h2 class="title">
            {{ $t('Settings') }}
          </h2>
          <div
            v-if="user && user.profile.gender !== 'female'"
            class="online-status"
          >
            <div>
              <h4>
                <feather-icon
                  icon="WifiIcon"
                  size="16"
                />
                {{ $t('Be Online') }}
              </h4>
              <p>
                {{ $t('You can allow other users to call you or turn it off') }}
              </p>
            </div>
            <div>
              <b-form-checkbox
                v-model="onlineStatus"
                class="custom-control-dark"
                switch
                button-variant="primary"
                :disabled="!user"
              />
            </div>
          </div>
          <b-button
            v-if="dropdownMenuShow"
            block
            variant="outline-primary"
            @click="dropdownIsOpen = !dropdownIsOpen"
          >
            <span>
              {{ $t('Settings Menu') }}
            </span>
            <font-awesome-icon
              v-if="dropdownIsOpen"
              icon="fa-solid fa-chevron-up"
            />
            <font-awesome-icon
              v-else
              icon="fa-solid fa-chevron-down"
            />
          </b-button>
          <input
            v-model="dropdownIsOpen"
            type="checkbox"
            style="display: none"
          >
          <div
            v-show="dropdownIsOpen"
            class="custom-dropdown-menu"
            @click="onMenuClick"
          >
            <router-link
              class="menu-item"
              :class="{active: $route.name === 'settings.profile-information'}"
              :to="{name: 'settings.profile-information'}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="UserIcon"
                  size="20"
                />
                {{ $t('Profile Information') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
            <router-link
              v-if="false"
              class="menu-item"
              :class="{active: $route.name === 'settings.interests'}"
              :to="{name: 'settings.interests'}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="HeartIcon"
                  size="20"
                />
                {{ $t('Interest Settings') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right"/>
              </span>
            </router-link>
            <router-link
              v-if="false"
              class="menu-item"
              :class="{active: $route.name === 'settings.filters'}"
              :to="{name: 'settings.filters'}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="FilterIcon"
                  size="20"
                />
                {{ $t('Filtering Settings') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
            <router-link
              class="menu-item"
              :class="{active: $route.name === 'settings.notifications'}"
              :to="{name: 'settings.notifications'}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="BellIcon"
                  size="20"
                />
                {{ $t('Notification Settings') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
            <router-link
              class="menu-item"
              :class="{active: $route.name === 'settings.about-us'}"
              :to="{name: 'settings.about-us'}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="InfoIcon"
                  size="20"
                />
                {{ $t('About Us') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
            <router-link
              class="menu-item"
              :class="{active: $route.name === 'settings.contact'}"
              :to="{name: 'settings.contact'}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="MailIcon"
                  size="20"
                />
                {{ $t('Contact Us') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
            <div
              class="menu-item"
              @click="showAccountSettings = !showAccountSettings"
              :class="{active: hasActiveRoute(['settings.remove-account', 'settings.update-password'])}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="SettingsIcon"
                  size="20"
                />
                {{ $t('Account Settings') }}
              </span>
              <span>
                <font-awesome-icon
                  v-if="!showAccountSettings"
                  icon="fa-solid fa-plus"
                />
                <font-awesome-icon
                  v-else
                  icon="fa-solid fa-minus"
                />
              </span>
            </div>
            <transition name="slide-down">
              <div
                v-if="showAccountSettings"
                class="submenu"
              >
<!--                <router-link class="menu-item" :class="{active: $route.name === 'settings.profile-information'}"-->
<!--                             :to="{name: 'settings.profile-information'}">-->
<!--                  <span>-->
<!--                    {{ $t('Profile') }}-->
<!--                  </span>-->
<!--                  <span>-->
<!--                    <font-awesome-icon icon="fa-solid fa-chevron-right"/>-->
<!--                  </span>-->
<!--                </router-link>-->
                <!--            <router-link class="menu-item" :class="{active: $route.name === 'settings.update-password'}"-->
                <!--                 :to="{name: 'settings.update-password'}">-->
                <!--              <span>-->
                <!--                Şifre Değiştirme-->
                <!--              </span>-->
                <!--              <span>-->
                <!--                <font-awesome-icon icon="fa-solid fa-chevron-right"/>-->
                <!--              </span>-->
                <!--            </router-link>-->
                <router-link
                  class="menu-item"
                  :class="{active: $route.name === 'settings.remove-account'}"
                  :to="{name: 'settings.remove-account'}"
                >
                  <span class="menu-label">
                    <feather-icon
                      icon="TrashIcon"
                      size="18"
                    />
                    {{ $t('Delete Account') }}
                  </span>
                  <span>
                    <font-awesome-icon icon="fa-solid fa-chevron-right" />
                  </span>
                </router-link>
              </div>
            </transition>
            <router-link
              class="menu-item"
              :class="{active: $route.name === 'settings.blocked'}"
              :to="{name: 'settings.blocked'}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="SlashIcon"
                  size="20"
                />
                {{ $t('Blocked') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
<!-- Hediye satışı kaldırıldı — ayarlardaki hediyeler girdisi devre dışı
            <router-link
              class="menu-item"
              :class="{active: $route.name === 'settings.gifts'}"
              :to="{name: 'settings.gifts'}"
            >
              <span>
                {{ $t('Gifts') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
            -->
            <router-link
              class="menu-item"
              :class="{active: $route.name === 'settings.faq'}"
              :to="{name: 'settings.faq'}"
            >
              <span class="menu-label">
                <feather-icon
                  icon="HelpCircleIcon"
                  size="20"
                />
                {{ $t('F.A.Q.') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
            <router-link
              class="menu-item"
              :class="{active: $route.name === 'settings.contracts'}"
              :to="{name: 'settings.contracts'}">
              <span class="menu-label">
                <feather-icon
                  icon="FileTextIcon"
                  size="20"
                />
                {{ $t('Membership Agreements') }}
              </span>
              <span>
                <font-awesome-icon icon="fa-solid fa-chevron-right" />
              </span>
            </router-link>
            <div
              class="menu-item"
              @click="logoutModal = true"
            >
              <span class="menu-label">
                <feather-icon
                  icon="LogOutIcon"
                  size="20"
                />
                {{ $t('Logout') }}
              </span>
            </div>
          </div>
        </b-col>
        <b-col
          class="page-setting"
          lg="9"
          md="8"
          sm="12"
        >
          <router-view
            :key="$route.fullPath"
          />
          <KeepAlive>
            <!--          <component :is="activeComponent" />-->
          </KeepAlive>
        </b-col>
      </b-row>

      <b-modal
        v-model="logoutModal"
        centered
        hide-header-close
        hide-footer
        size="sm"
      >
        <div class="mb-3">
          {{ $t('Are you sure you want to logout Boho?') }}
        </div>
        <b-button
          class="px-4 mr-2"
          variant="light"
          size="sm"
          @click="logoutModal = false"
        >
          {{ $t('Cancel') }}
        </b-button>
        <b-button
          class="px-4"
          variant="primary"
          size="sm"
          @click="logout"
        >
          {{ $t('Logout') }}
        </b-button>
      </b-modal>
    </b-overlay>
  </section>
</template>

<script>
import {
  gtmTrackNewEvent, logout, throwDefaultError,
} from '@/helpers/helpers'
import {
  BButton, BCol, BFormCheckbox, BModal, BOverlay, BRow,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'

// import { getUser } from '@/auth/utils'

export default {
  components: {
    BButton,
    BCol,
    BFormCheckbox,
    BModal,
    BOverlay,
    BRow,
  },
  data() {
    return {
      activeComponent: 'UpdateEmail',
      dropdownIsOpen: true,
      dropdownMenuShow: false,
      loading: false,
      logoutModal: false,
      onlineStatus: false,
      showAccountSettings: false,
      user: null,
      watchOnlineStatus: false,
    }
  },
  computed: {
    userOnlineStatus() {
      return this.$store.getters['auth/userOnlineStatus']
    },
    userCanStartVideoCall() {
      return this.$store.getters['auth/userCanStartVideoCall']
    },
    userFreeCallUser() {
      return this.$store.getters['auth/freeCallUser']
    },
    userGender() {
      return this.$store.getters['auth/userGender']
    },
    userSource() {
      return this.$store.getters['auth/userSource']
    },
  },
  watch: {
    onlineStatus(val) {
      if (this.watchOnlineStatus) {
        this.updateOnlineStatus()

        gtmTrackNewEvent('changeonlinestatus', {
          category: 'Hesap',
          action: 'ChangeOnlineStatus',
          label: val ? 'Online' : 'Offline',
        })
      }
    },
    $route() {
      this.dropdownIsOpen = false
    },
    userOnlineStatus(val) {
      this.watchOnlineStatus = false
      this.onlineStatus = val === 'online'
      setTimeout(() => {
        this.watchOnlineStatus = true
      }, 11)
    },
  },
  created() {
    this.getMe()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    this.onResize()
  },
  updated() {
    this.onResize(true)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    getMe() {
      useJwt.getMe()
        .then(response => {
          this.watchOnlineStatus = false
          this.user = response.data.body
          this.onlineStatus = this.user.profile.onlineStatus === 'online'
          this.$store.dispatch('auth/updateUser', this.user)
          setTimeout(() => {
            this.watchOnlineStatus = true
          }, 11)
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
    },
    // Mobilde bir sayfa seçilince (aynı sayfa olsa bile) menü kapansın
    onMenuClick(event) {
      if (!this.dropdownMenuShow) return
      const link = event.target && event.target.closest ? event.target.closest('a.menu-item') : null
      if (link) {
        this.dropdownIsOpen = false
      }
    },
    hasActiveRoute(names) {
      let result = false
      names.forEach(name => {
        if (name === this.$route.name) {
          result = true
        }
      })
      return result
    },
    logout() {
      gtmTrackNewEvent('logout', {
        category: 'Hesap',
        action: 'Logout',
      })

      logout(this.$ability, this.$router)
    },
    onResize(isUpdated = false) {
      if (window.innerWidth <= 770) {
        if (!isUpdated) {
          this.dropdownIsOpen = false
          this.dropdownMenuShow = true
        }
      } else {
        this.dropdownIsOpen = true
        this.dropdownMenuShow = false
      }
    },
    updateOnlineStatus() {
      this.loading = true

      useJwt.updateOnlineStatus(this.onlineStatus ? 'online' : 'offline')
        .then(response => {
          this.onlineStatus = response.data.body.onlineStatus === 'online'
          this.getMe()
        })
        .catch(() => {})
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style lang="scss">
#page-settings {
  /* .page sınıfı içeriği kenara çektiği için iki yana iç boşluk */
  padding: 16px 28px 24px;

  @media (max-width: 991px) {
    padding: 12px 16px 20px;
  }

  @media (max-width: 575px) {
    padding: 8px 4px 16px;
  }

  .left-menu {
    margin-bottom: 20px;

    > * {
      position: relative;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 15px;
      right: 15px;
      background: rgba(32, 22, 72, 0.72);
      border: 1px solid rgba(150, 110, 255, 0.28);
      border-radius: 20px;
      box-shadow: 0 12px 40px rgba(6, 2, 24, 0.45);
    }

    padding: 20px 31px;
    /* min-device-width yerine min-width: dar ekranda menü boydan boya uzayıp içeriği aşağı itmesin */
    @media (min-width: 771px) {
      min-height: calc(100vh - 190px);
    }

    @media (max-width: 770px) {
      padding: 16px 27px;
      margin-bottom: 16px;
    }

    .title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 16px;
      padding-bottom: 14px;
      border-bottom: 1px solid rgba(150, 110, 255, 0.2);
    }

    .online-status {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      background: rgba(14, 10, 40, 0.45);
      border: 1px solid rgba(150, 110, 255, 0.18);
      border-radius: 14px;
      padding: 14px 15px;
      margin-bottom: 14px;

      h4 {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: 'Lexend', sans-serif;
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: #fff;
        margin-bottom: 4px;
      }

      p {
        font-family: 'Lexend', sans-serif;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: rgba(226, 220, 255, 0.68);
        margin: 0;
      }
    }

    .btn-outline-primary {
      color: #fff;
      border-color: rgba(170, 140, 255, 0.4);
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }

    .submenu {
      padding-left: 22px;
    }

    .menu-item {
      font-weight: 500;
      font-size: 15px;
      line-height: 20px;
      color: rgba(236, 232, 255, 0.85);
      margin-bottom: 6px;
      padding: 12px 14px;
      border-radius: 12px;
      border: 1px solid transparent;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: background .15s ease, color .15s ease;

      .menu-label {
        display: flex;
        align-items: center;
        gap: 14px;
      }

      &:hover {
        color: #fff;
        background: rgba(139, 92, 246, 0.14);
        text-decoration: none;
      }
    }

    /* Menübardaki seçili sekmeyle aynı gradyan */
    .menu-item.active {
      font-weight: 700;
      color: #fff;
      background: linear-gradient(135deg, rgba(234, 3, 178, 0.28) 0%, rgba(168, 85, 247, 0.22) 50%, rgba(99, 102, 241, 0.12) 100%);
      border: 1px solid rgba(234, 3, 178, 0.35);
      box-shadow: 0 2px 14px rgba(234, 3, 178, 0.18), inset 0 1px 1px rgba(255, 255, 255, 0.25), inset 0 0 12px rgba(234, 3, 178, 0.12);
      backdrop-filter: blur(12px);

      svg {
        filter: drop-shadow(0 0 4px rgba(234, 3, 178, 0.55));
      }

      .menu-label {
        text-shadow: 0 0 8px rgba(234, 3, 178, 0.35);
      }
    }
  }

  .page-setting {
    color: #000;
    /* menü ile içerik arasında boşluk */
    padding: 0 40px 40px 52px;

    @media (max-width: 767px) {
      padding: 0 40px 32px;
    }

    h3 {
      font-weight: 600;
      font-size: 22px;
      line-height: 28px;
      color: #000;
    }

    .notifications {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
